import Axios from 'axios'
import Moment from 'moment'

const traceabilitySearchService = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.TRACEABILITY_BASE_URL
    return AxiosInstance
  },
  axiosForBackend() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.API_URL
    return AxiosInstance
  },
  getTraceabilityOrderByPatientName(patientName) {
    return this.axios().put('/exams/filters', { patientName: patientName })
  },
  getTraceabilityOrderBySampleID(id) {
    return this.axios().put('/exams/filters', { sampleId: id })
  },
  getTraceabilityOrderByOSLis(id) {
    return this.axios().put('/exams/filters', { idOsLis: id })
  },
  getTraceabilityOrderByBatch(id) {
    return this.axios().put('/exams/filters', { idLot: id })
  },
  getTraceabilityOrderByOrderId(orderId) {
    return this.axios().get('/exams/orders/' + orderId)
  },
  getTraceabilityOrderByDate(startDate, endDate) {
    return this.axios().get('/exams/search', {
      params: {
        startDate: Moment(startDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        endDate: Moment(endDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      },
    })
  },
  getTraceabilityByStatusExam(status, placeExecution) {
    const nto = placeExecution ? `&nto=${placeExecution}` : ''

    if (status === 'ATRASADO') return this.axios().get('/exams/delay')
    return this.axios().get(
      `/exams/status?status=${status === 'EM_TRANSITO' ? 'EM_TRANSITO_ENTRE_NTO, EM_TRANSITO' : status}${nto}`
    )
  },
  getCurrentBatchCoordinates(batchBarcode) {
    return this.axiosForBackend().get(
      '/traceability/exam-order-coordinates/' + batchBarcode
    )
  },
  getPlaceExecutionCoordinates(placeExecutionId) {
    return this.axiosForBackend().get('/placeExecution/' + placeExecutionId)
  },
  getGroupedExams(
    params = { filterType: '', filterValue: '', status: '', limit: 20, nextCursor: '' }
  ) {
    return this.axios().get('/exams/grouped', { params })
  },
  getGroupedExamsCount(params = { filterType: '', filterValue: '', status: '' }) {
    return this.axios().get('/exams/grouped/count', { params })
  },
}

export default traceabilitySearchService
